import React from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
  Divider,
  Avatar,
  Link,
  IconButton,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { COLORS } from "../../constants";

const MobileTeam = ({
  heading,
  description,
  teamInfo,
  selectedTeam,
  handleTeamSelect,
  selectedTeamData,
}) => (
  <Grid container spacing={1} sx={{ flexDirection: "column", my: 1 }}>
    <Grid item xs={12}>
      <Box
        sx={{
          borderRadius: "2px",
        }}
      >
        <Typography
          sx={{
            paddingLeft: 0,
            fontSize: "var(--font-size-l)",
            fontWeight: 500,
            lineHeight: "var(--spacing-xxl)",
            color: COLORS.darkText,
          }}
        >
          {heading}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: COLORS.lightText,
            mb: 2,
            lineHeight: 1.8,
            mt: 1,
            fontSize: "var(--font-size-xxs)",
          }}
        >
          {description}
        </Typography>

        <Box
          sx={{
            display: "flex",
            gap: 2,
            mt: 2,
            mb: 4,
            width: "100%",
            overflowX: "auto",
            scrollSnapType: "x mandatory",
            "-webkit-overflow-scrolling": "touch",
            "&::-webkit-scrollbar": {
              display: "none",
            },
            scrollbarWidth: "none",
          }}
        >
          {teamInfo.map((team) => (
            <Button
              key={team.title}
              onClick={() => handleTeamSelect(team.title)}
              sx={{
                backgroundColor:
                  selectedTeam === team.title ? COLORS.themeRed : COLORS.white,
                borderRadius: "99px",
                color: selectedTeam === team.title ? COLORS.white : COLORS.gray,
                border:
                  selectedTeam === team.title
                    ? "none"
                    : `1px solid ${COLORS.border}`,
                px: 4,
                py: 1,
                cursor: "pointer",
                flexShrink: 0,
                "&:hover": {
                  backgroundColor:
                    selectedTeam === team.title
                      ? COLORS.themeRed
                      : COLORS.border,
                },
              }}
            >
              <Typography
                sx={{
                  textAlign: "center",
                  justifySelf: "center",
                  fontSize: "var(--font-size-xxs)",
                }}
              >
                {team.title}
              </Typography>
            </Button>
          ))}
        </Box>
      </Box>
    </Grid>
    <Grid item xs={12}>
      <Grid container spacing={2}>
        {selectedTeamData?.members.map((member) => (
          <Grid item xs={6} key={member.name}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                backgroundColor: COLORS.white,
                border: `1px solid ${COLORS.border}`,
                borderRadius: "2px",
                p: 1,
                height: "100%",
                boxSizing: "border-box",
              }}
            >
              <Avatar
                alt={member.name}
                src={member.image}
                sx={{ width: 100, height: 100, mb: 1 }}
              />
              <Box sx={{ display: "flex", alignItems: "center", mb: 0.5 }}>
                <Typography
                  sx={{
                    color: COLORS.darkText,
                    textTransform: "capitalize",
                    fontSize: "0.7rem",
                    fontWeight: 500,
                  }}
                >
                  {member.name}
                </Typography>
                {selectedTeam !== "Management" && member.linkedin && (
                  <IconButton
                    sx={{ color: COLORS.themeBlue, ml: 0, p: 0 }}
                    href={member.linkedin}
                    target="_blank"
                    rel="noopener"
                  >
                    <LinkedInIcon sx={{ fontSize: "var(--font-size-xs)" }} />
                  </IconButton>
                )}
              </Box>
              {member.role && (
                <Typography
                  variant="body2"
                  sx={{ color: COLORS.lightText, mb: 0.5, fontSize: "0.7rem" }}
                >
                  {member.role}
                </Typography>
              )}
              {selectedTeam !== "Management" && member.email && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mb: 0.5,
                    maxWidth: "100%",
                  }}
                >
                  <Box
                    sx={{
                      width: 30,
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <IconButton sx={{ color: COLORS.gray, p: 0.5 }}>
                      <EmailIcon sx={{ fontSize: "var(--font-size-s)" }} />
                    </IconButton>
                  </Box>
                  <Link
                    href={`mailto:${member.email}`}
                    sx={{
                      color: COLORS.darkText,
                      textDecoration: "none",
                      "&:hover": { textDecoration: "underline" },
                      fontSize: "0.7rem",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      flex: 1,
                    }}
                  >
                    {member.email}
                  </Link>
                </Box>
              )}
              {selectedTeam !== "Management" && member.phone && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mb: 0.5,
                    maxWidth: "100%",
                  }}
                >
                  <Box
                    sx={{
                      width: 30,
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <IconButton sx={{ color: COLORS.gray, p: 0.5 }}>
                      <PhoneIcon sx={{ fontSize: "var(--font-size-s)" }} />
                    </IconButton>
                  </Box>
                  <Link
                    href={`tel:${member.phone}`}
                    sx={{
                      color: COLORS.darkText,
                      textDecoration: "none",
                      "&:hover": { textDecoration: "underline" },
                      fontSize: "0.7rem",
                      flex: 1,
                    }}
                  >
                    {member.phone}
                  </Link>
                </Box>
              )}
              {selectedTeam !== "Management" && member.whatsapp && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    maxWidth: "100%",
                  }}
                >
                  <Box
                    sx={{
                      width: 30,
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <IconButton sx={{ color: COLORS.gray, p: 0.5 }}>
                      <WhatsAppIcon sx={{ fontSize: "var(--font-size-s)" }} />
                    </IconButton>
                  </Box>
                  <Link
                    href={`https://wa.me/${member.whatsapp}`}
                    sx={{
                      color: COLORS.darkText,
                      textDecoration: "none",
                      "&:hover": { textDecoration: "underline" },
                      fontSize: "0.7rem",
                      flex: 1,
                    }}
                  >
                    {member.whatsapp}
                  </Link>
                </Box>
              )}
            </Box>
          </Grid>
        ))}
      </Grid>
    </Grid>
  </Grid>
);

export default MobileTeam;
